export default function PhoneMockup() {
  return (
    <svg
      className="phone-illustration"
      viewBox="0 0 380 520"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Aperçu de l'application mobile Masomo sur un smartphone"
    >
      <path
        className="illus-blob"
        d="M200 20C280 24 340 80 350 160C360 250 320 340 240 380C160 420 60 400 30 320C0 240 30 140 100 80C130 54 160 18 200 20Z"
        fill="#EEF2FF"
      />

      {/* phone frame */}
      <g transform="translate(90 40)">
        <rect x="0" y="0" width="200" height="420" rx="34" fill="#1E1B2E" />
        <rect x="8" y="14" width="184" height="392" rx="22" fill="#FFFFFF" />
        <rect x="70" y="4" width="60" height="10" rx="5" fill="#1E1B2E" />

        {/* status/app header */}
        <rect x="8" y="14" width="184" height="64" rx="22" fill="#305CDE" />
        <circle cx="34" cy="46" r="14" fill="#FDB022" />
        <rect x="56" y="36" width="80" height="8" rx="4" fill="#EEF2FF" />
        <rect x="56" y="50" width="56" height="6" rx="3" fill="#A5B4FC" />

        {/* course cards */}
        <rect x="22" y="96" width="156" height="58" rx="14" fill="#ECFDF5" />
        <circle cx="46" cy="125" r="16" fill="#10B981" />
        <rect x="72" y="112" width="90" height="8" rx="4" fill="#065F46" opacity="0.7" />
        <rect x="72" y="126" width="60" height="6" rx="3" fill="#10B981" opacity="0.6" />

        <rect x="22" y="164" width="156" height="58" rx="14" fill="#FFF7E6" />
        <circle cx="46" cy="193" r="16" fill="#FDB022" />
        <rect x="72" y="180" width="90" height="8" rx="4" fill="#92400E" opacity="0.7" />
        <rect x="72" y="194" width="60" height="6" rx="3" fill="#FDB022" opacity="0.7" />

        <rect x="22" y="232" width="156" height="58" rx="14" fill="#FFEEF0" />
        <circle cx="46" cy="261" r="16" fill="#FB7185" />
        <rect x="72" y="248" width="90" height="8" rx="4" fill="#9F1239" opacity="0.6" />
        <rect x="72" y="262" width="60" height="6" rx="3" fill="#FB7185" opacity="0.7" />

        {/* bottom nav */}
        <rect x="8" y="360" width="184" height="46" rx="22" fill="#F6F4FF" />
        <circle cx="46" cy="383" r="10" fill="#305CDE" />
        <circle cx="100" cy="383" r="10" fill="#D8D4F0" />
        <circle cx="154" cy="383" r="10" fill="#D8D4F0" />
      </g>

      {/* floating notification */}
      <g className="illus-float" style={{ animationDelay: "0.3s" }} transform="translate(20 120)">
        <rect width="120" height="52" rx="14" fill="#FFFFFF" stroke="#ECE9F5" strokeWidth="2" />
        <circle cx="26" cy="26" r="14" fill="#10B981" />
        <path d="M20 26 L24 30 L33 20" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="48" y="16" width="58" height="7" rx="3.5" fill="#1E1B2E" opacity="0.7" />
        <rect x="48" y="29" width="40" height="6" rx="3" fill="#6B6478" opacity="0.5" />
      </g>

      <g className="illus-float" style={{ animationDelay: "0.9s" }} transform="translate(280 300)">
        <circle cx="26" cy="26" r="26" fill="#FDB022" />
        <path
          d="M26 10 L30.6 21.6 L43 22.8 L33.6 31 L36.6 43 L26 36.2 L15.4 43 L18.4 31 L9 22.8 L21.4 21.6Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
